import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link,useNavigate } from "react-router-dom";
import { GetGuadinaSetList } from "../../api/get";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { handleApiError } from "../../Common/Helper";
const GuardianReview = () => {
  const [guardianSetList, setGuardianSetList] = useState([]);
  const [contentLoder, setContentLoader] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    GetGuadinaSetList()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setGuardianSetList(res.data);
          setContentLoader(false);
          console.log(res);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  // Determine which ID and type to use based on the presence of child or pet data
  const { child, pets } = guardianSetList || {};
  const firstData =
    (child && child.length > 0 ? child[0] : pets && pets[0]) || {};
  console.log("firstData =>", firstData);

  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 mt-[30px] max-lg:grid-cols-1">
              <div>
                <p className="text-[26px] font-semibold">About guardians</p>
                <p className="my-1 text-slate-500">
                  If you have children under the age of 18, it’s a great idea to
                  choose a legal guardian for them in your will.
                </p>
                <p className="my-1 text-slate-500">
                  A guardian should be someone you trust to step in and look
                  after your child if both you and their other parent die before
                  they become an adult.
                </p>
                <p className="my-1 text-slate-500">
                  This section is optional — feel free to skip ahead. You can
                  always come back to it later.
                </p>
                <div className="mt-[20px]">
                  <div className="py-5 border-b-2">
                    <div className="border-black rounded-xl border-[1px] p-3">
                      <div className="flex gap-5">
                        <div className="w-[10%]">
                          <img
                            src="/assets/images/write-icon.png"
                            alt="write"
                          />
                        </div>
                        <div className="w-[100%]">
                          <p className="text-[20px] my-3 font-bold">
                            Unlimited changes!
                          </p>
                          <p className="text-[18px] text-slate-500">
                            With WillsGuru, you can get unlimited updates to
                            your will. So if you change your mind about who
                            should get what, you can always log in later and
                            make changes. We’ll even check your will again for
                            you. For now, it’s important just to get a copy
                            signed ASAP.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-5 flex justify-between items-center">
                    <div className="flex  pb-5">
                      <Link to={"/dashboard"}>
                        <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                          <FaAngleLeft />
                          Back
                        </button>
                      </Link>
                    </div>
                    <div className="flex  pb-5">
                      <Link
                        to={`/guardian/review/list/${firstData.id}/${firstData.current_type}`}
                        state={{
                          key: firstData?.id,
                          type: firstData?.current_type,
                        }}
                      >
                        <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                          Next <FaChevronRight />
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GuardianReview;
